import { Languages } from 'lucide-react';
import { PORTAL_URL } from '@/lib/config';
import { setLang, t, useLang, type StringTable } from '@/lib/i18n';
import { Logo } from './logo';

const STRINGS = {
  'nav.how': { en: 'How it works', fa: 'چگونه کار می‌کند' },
  'nav.features': { en: 'Capabilities', fa: 'قابلیت‌ها' },
  'nav.pricing': { en: 'Pricing', fa: 'قیمت‌گذاری' },
  'nav.contact': { en: 'Contact', fa: 'تماس' },
  'nav.signin': { en: 'Sign in', fa: 'ورود' },
  'nav.launch': { en: 'Request access', fa: 'درخواست دسترسی' },
  'nav.lang.toggle.aria': {
    en: 'Switch language to Persian',
    fa: 'تغییر زبان به انگلیسی',
  },
  'nav.lang.label': { en: 'فا', fa: 'EN' },
} satisfies StringTable<string>;

export function Nav() {
  const lang = useLang();
  const next = lang === 'en' ? 'fa' : 'en';

  return (
    <nav className="glass-nav sticky top-0 z-20">
      <div className="mx-auto flex h-14 max-w-[88rem] items-center gap-6 px-6">
        <a
          href="/"
          className="flex items-center gap-2.5 font-serif text-[var(--color-ink)]"
          aria-label="Jam-e Jam — home"
        >
          <Logo size={28} ring className="text-[var(--color-ink)]" />
          <span className="flex items-baseline gap-2">
            <span className="text-lg">Jam-e Jam</span>
            <span className="text-xxs uppercase tracking-wider text-[var(--color-ink-muted)]">
              جامِ جم
            </span>
          </span>
        </a>

        <div className="ms-auto hidden items-center gap-6 text-sm text-[var(--color-ink-secondary)] md:flex">
          <a href="#how" className="hover:text-[var(--color-ink)]">
            {t(STRINGS, 'nav.how', lang)}
          </a>
          <a href="#features" className="hover:text-[var(--color-ink)]">
            {t(STRINGS, 'nav.features', lang)}
          </a>
          <a href="#pricing" className="hover:text-[var(--color-ink)]">
            {t(STRINGS, 'nav.pricing', lang)}
          </a>
          <a href="#contact" className="hover:text-[var(--color-ink)]">
            {t(STRINGS, 'nav.contact', lang)}
          </a>
        </div>

        <div className="ms-auto flex items-center gap-2 md:ms-0">
          <button
            type="button"
            onClick={() => setLang(next)}
            aria-label={t(STRINGS, 'nav.lang.toggle.aria', lang)}
            className="inline-flex items-center gap-1.5 rounded-sm border border-[var(--color-border)] bg-[var(--color-surface)] px-2.5 py-1.5 text-xs font-mono uppercase tracking-wider text-[var(--color-ink-secondary)] transition-colors hover:border-[var(--color-accent)] hover:text-[var(--color-ink)]"
          >
            <Languages className="size-3.5" />
            <span>{t(STRINGS, 'nav.lang.label', lang)}</span>
          </button>

          <a
            href={`${PORTAL_URL}/sign-in`}
            target="_self"
            className="hidden rounded-sm border border-transparent px-3 py-1.5 text-sm text-[var(--color-ink-secondary)] hover:text-[var(--color-ink)] sm:inline"
          >
            {t(STRINGS, 'nav.signin', lang)}
          </a>
          <a
            href={`${PORTAL_URL}/sign-up`}
            target="_self"
            className="rounded-sm bg-[var(--color-ink)] px-3 py-1.5 text-sm text-[var(--color-canvas)] transition-colors hover:bg-[var(--color-accent)]"
          >
            {t(STRINGS, 'nav.launch', lang)}
          </a>
        </div>
      </div>
    </nav>
  );
}
